/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

export const HamburgerButton = ( props ) => {
    const [ visible, setVisibility ] = useState( false );

    const updateVisibility = useCallback( ( enabled, executeCallbacks = true ) => {
        if ( visible !== enabled ) {
            // Execute the provided callbacks as needed.
            if ( executeCallbacks ) {
                if ( enabled && props.onShow ) {
                    props.onShow();
                } else if ( !enabled && props.onHide ) {
                    props.onHide();
                }

                if ( props.onToggle ) {
                    props.onToggle( enabled );
                }
            }

            // Update the state.
            setVisibility( enabled );
        }
    }, [ visible, setVisibility, props.onShow, props.onHide, props.onToggle ] );

    const handleToggle = useCallback( () => {
        updateVisibility( !visible );
    }, [ visible, updateVisibility ] );

    useEffect( () => {
        if ( props.show !== undefined ) {
            updateVisibility( props.show );
        }
    }, [ updateVisibility, props.show ] );

    useEffect( () => {
        if ( props.getController ) {
            props.getController( {
                toggle: handleToggle,
                setVisibility: ( value ) => updateVisibility( value ),
            } );
        }
    }, [ updateVisibility, props.getController, handleToggle ] );

    // Construct the classes to use for the component root.
    const rootClasses = classNames(
        'hamburger-button',
        { 'expanded': visible },
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <button
            aria-label={ 'Menu' } // TODO: Get translated label
            className={ rootClasses }
            style={ props.style }
            onClick={ props.onClick ? props.onClick : handleToggle }
        >
            <div id="hamburger-bar-1" className="hamburger-bar" />
            <div id="hamburger-bar-2" className="hamburger-bar" />
            <div id="hamburger-bar-3" className="hamburger-bar" />
        </button>
    );
};

/**
 * The default properties used for this component if values aren't given
 * to the component externally.
 */
HamburgerButton.defaultProps = {
    className: undefined,
    style: undefined,

    getController: undefined,
    onShow: undefined,
    onHide: undefined,
    onToggle: undefined,

    // Props to overwrite default behavior for more control.
    show: undefined,
    onClick: undefined,
};

/**
 * The type definitions of the properties this component accepts.
 */
HamburgerButton.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,

    getController: PropTypes.func,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    onToggle: PropTypes.func,

    // Props to overwrite default behavior for more control.
    show: PropTypes.bool,
    onClick: PropTypes.func,
};
